export default __webpack_public_path__ + "static/media/doorscratchbefore.ff42b691.jpg";